import { useLang } from '@/i18n/LanguageContext';
import { SITE } from '@/content/site';
import MaskLines from '@/components/MaskLines';

export default function Rooms() {
  const { t } = useLang();
  return (
    <section id="experience" className="px-5 py-28 md:px-10 md:py-36" data-testid="section-rooms">
      <p className="font-mono-label text-[var(--pz-green)]">{t.rooms.kicker}</p>
      <h2 className="font-display mt-6 text-[10.5vw] leading-[0.9] md:text-[6vw]">
        <MaskLines lines={t.rooms.headline} />
      </h2>

      <ul className="mt-16 flex flex-wrap items-baseline gap-x-10 gap-y-5" data-testid="rooms-list">
        {t.rooms.realities.map((name, i) => (
          <li key={name} className="flex items-baseline gap-3">
            <span className="font-mono-label text-white/35">{String(i + 1).padStart(2, '0')}</span>
            <span
              data-testid={`room-${i + 1}`}
              className="font-display cursor-default text-3xl text-white/85 transition-colors duration-300 hover:text-[var(--pz-green)] md:text-5xl"
            >
              {name}
            </span>
          </li>
        ))}
      </ul>

      <p className="font-mono-label mt-12 max-w-xl text-white/45" style={{ textTransform: 'none', letterSpacing: '0.06em' }}>
        {t.rooms.note}
      </p>
      <p className="font-mono-label mt-8">
        <span className="text-white/45">{t.rooms.seenOn} — </span>
        <a
          data-testid="rooms-press-link"
          href={SITE.press.url}
          target="_blank"
          rel="noopener noreferrer"
          className="link-underline text-[var(--pz-green)]"
        >
          {SITE.press.label} · {SITE.press.year} ↗
        </a>
      </p>
    </section>
  );
}
